import { SharedModule } from '@bb-vendure/admin-ui/core';
import { Component, Input } from "@angular/core";

@Component({
    selector: 'inbound-expand-content',
    standalone: true,
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    imports: [SharedModule]
}) export default class InboundExpandContent {
    @Input() item: any;
    @Input() index: number;
}